import { put, takeLatest, all } from 'redux-saga/effects';
import { notification } from 'antd';
import TrackerActions from '@Actions/trackerActions';
import PurchaseRequestActions, { purchaseRequestActionTypes } from '../actions/purchaseRequestActions';
import PurchaseRequestServices from '../services/purchaseRequestServices';

/**
 * @param action
 */
function* _getDownloadPRData(action) {
  const { payload, callback } = action;
  try {
    yield put(PurchaseRequestActions.getDownloadPRDataLoading(true));
    const prData = yield PurchaseRequestServices.downloadPRData(payload);
    if (prData?.success) {
      notification.open({
        type: 'success',
        message: 'Your request is being processed. You will receive the data on your email.',
        duration: 4,
        placement: 'top',
      });
      if (callback) {
        callback();
      }
    } else {
      notification.open({
        type: 'error',
        message: prData.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(PurchaseRequestActions.getDownloadPRDataLoading(false));
  } catch (error) {
    yield put(PurchaseRequestActions.getDownloadPRDataLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(purchaseRequestActionTypes.GET_DOWNLOAD_PURCHASE_REQUEST_DATA.ERROR, error));
  }
}

function* downloadPRData() {
  yield takeLatest(purchaseRequestActionTypes.GET_DOWNLOAD_PURCHASE_REQUEST_DATA.REQUEST, _getDownloadPRData);
}

/**
 * @param action
 */
function* _getPurchaseRequests(action) {
  try {
    yield put(PurchaseRequestActions.getPurchaseRequestsLoading(true));
    const {
      tenantId, status, fromDate, toDate, deliveryFromDate, deliveryToDate, tenantRoleId, page, limit, searchKeyword, tenantDepartmentId, moId, prId, sourceDepartmentId, departmentId, productSearch, label, mrpId, fulfillmentStatus, isListScreen
    } = action;
    const purchaseRequests = yield PurchaseRequestServices.getPurchaseRequests(tenantId, status, fromDate, toDate, deliveryFromDate, deliveryToDate, tenantRoleId, page, limit, searchKeyword, tenantDepartmentId, moId, prId, sourceDepartmentId, departmentId, productSearch, label, mrpId, fulfillmentStatus, isListScreen);
    yield put(PurchaseRequestActions.getPurchaseRequestsSuccess(purchaseRequests));
    if (action.callback) {
      action.callback(purchaseRequests);
    }
    yield put(PurchaseRequestActions.getPurchaseRequestsLoading(false));
  } catch (error) {
    yield put(PurchaseRequestActions.getPurchaseRequestsLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(purchaseRequestActionTypes.GET_PURCHASE_REQUESTS.ERROR, error));
  }
}

/**
 *
 */
function* getPurchaseRequests() {
  yield takeLatest(purchaseRequestActionTypes.GET_PURCHASE_REQUESTS.REQUEST, _getPurchaseRequests);
}

/**
 * @param action
 */
function* _getPurchaseRequestById(action) {
  try {
    yield put(PurchaseRequestActions.getPurchaseRequestByIdSuccess(null));
    yield put(PurchaseRequestActions.getPurchaseRequestByIdLoading(true));
    const { prId, tenantId } = action;
    const selectedPurchaseRequest = yield PurchaseRequestServices.getPurchaseRequestById(prId, tenantId);
    yield put(PurchaseRequestActions.getPurchaseRequestByIdSuccess(selectedPurchaseRequest?.purchase_requisition?.[0]));
    if (action.callback) {
      action.callback(selectedPurchaseRequest);
    }
    yield put(PurchaseRequestActions.getPurchaseRequestByIdLoading(false));
  } catch (error) {
    yield put(PurchaseRequestActions.getPurchaseRequestByIdLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(purchaseRequestActionTypes.GET_PURCHASE_REQUEST_BY_ID.ERROR, error));
  }
}

/**
 *
 */
function* getPurchaseRequestById() {
  yield takeLatest(purchaseRequestActionTypes.GET_PURCHASE_REQUEST_BY_ID.REQUEST, _getPurchaseRequestById);
}

/**
 * @param action
 */
function* _createPurchaseRequest(action) {
  try {
    yield put(PurchaseRequestActions.createPurchaseRequestLoading(true));
    const { payload } = action;
    const purchaseRequest = yield PurchaseRequestServices.createPurchaseRequest(payload);
    if (purchaseRequest.success) {
      yield put(TrackerActions.trackAction(purchaseRequestActionTypes.CREATE_PURCHASE_REQUEST.SUCCESS, purchaseRequest.data));
      notification.open({
        type: 'success',
        message: 'Material request successfully created',
        duration: 4,
        placement: 'top',
      });
      if (action.callback) {
        action.callback(purchaseRequest);
      }
    } else {
      notification.open({
        type: 'error',
        message: purchaseRequest.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(PurchaseRequestActions.createPurchaseRequestLoading(false));
  } catch (error) {
    yield put(PurchaseRequestActions.createPurchaseRequestLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(purchaseRequestActionTypes.CREATE_PURCHASE_REQUEST.ERROR, error));
  }
}

/**
 *
 */
function* createPurchaseRequest() {
  yield takeLatest(purchaseRequestActionTypes.CREATE_PURCHASE_REQUEST.REQUEST, _createPurchaseRequest);
}

/**
 * @param action
 */
function* _updatePurchaseRequest(action) {
  try {
    yield put(PurchaseRequestActions.updatePurchaseRequestLoading(true));
    const { payload } = action;
    const purchaseRequest = yield PurchaseRequestServices.updatePurchaseRequest(payload);
    if (!purchaseRequest.success) {
      notification.open({
        type: 'error',
        message: purchaseRequest.messages,
        duration: 4,
        placement: 'top',
      });
    } else if (action.callback) {
      yield put(TrackerActions.trackAction(purchaseRequestActionTypes.UPDATE_PURCHASE_REQUEST.SUCCESS, purchaseRequest.data));
      notification.open({
        type: 'success',
        message: 'Material request successfully updated',
        duration: 4,
        placement: 'top',
      });
      action.callback(purchaseRequest?.purchase_requisition);
    }
    yield put(PurchaseRequestActions.updatePurchaseRequestLoading(false));
  } catch (error) {
    yield put(PurchaseRequestActions.updatePurchaseRequestLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(purchaseRequestActionTypes.UPDATE_PURCHASE_REQUEST.ERROR, error));
  }
}

/**
 *
 */
function* updatePurchaseRequest() {
  yield takeLatest(purchaseRequestActionTypes.UPDATE_PURCHASE_REQUEST.REQUEST, _updatePurchaseRequest);
}

/**
 * @param action
 */
function* _deletePurchaseRequest(action) {
  try {
    yield put(PurchaseRequestActions.deletePurchaseRequestLoading(true));
    const { payload } = action;
    const purchaseRequest = yield PurchaseRequestServices.deletePurchaseRequest(payload);
    if (purchaseRequest.success) {
      notification.open({
        type: 'success',
        message: 'Material request deleted successfully',
        duration: 4,
        placement: 'top',
      });
      if (action.callback) {
        action.callback(purchaseRequest);
      }
    } else {
      notification.open({
        type: 'error',
        message: purchaseRequest.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(PurchaseRequestActions.deletePurchaseRequestLoading(false));
  } catch (error) {
    yield put(PurchaseRequestActions.deletePurchaseRequestLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(purchaseRequestActionTypes.DELETE_PURCHASE_REQUEST.ERROR, error));
  }
}

/**
 *
 */
function* deletePurchaseRequest() {
  yield takeLatest(purchaseRequestActionTypes.DELETE_PURCHASE_REQUEST.REQUEST, _deletePurchaseRequest);
}

/**
 * @param action
 */
function* _updatePurchaseRequestStatus(action) {
  try {
    yield put(PurchaseRequestActions.updatePurchaseRequestStatusLoading(true));
    const { payload } = action;
    const purchaseRequest = yield PurchaseRequestServices.updatePrStatus(payload);
    if (purchaseRequest.success) {
      notification.open({
        type: 'success',
        message: 'Material request status updated successfully',
        duration: 4,
        placement: 'top',
      });
      if (action.callback) {
        action.callback(purchaseRequest);
      }
    } else {
      notification.open({
        type: 'error',
        message: purchaseRequest.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(PurchaseRequestActions.updatePurchaseRequestStatusLoading(false));
  } catch (error) {
    yield put(PurchaseRequestActions.updatePurchaseRequestStatusLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(purchaseRequestActionTypes.UPDATE_PURCHASE_REQUEST_STATUS.ERROR, error));
  }
}

/**
 *
 */
function* updatePurchaseRequestStatus() {
  yield takeLatest(purchaseRequestActionTypes.UPDATE_PURCHASE_REQUEST_STATUS.REQUEST, _updatePurchaseRequestStatus);
}

/**
 * @param action
 */
function* _getPrSequence(action) {
  try {
    yield put(PurchaseRequestActions.getPrSequenceLoading(true));
    const { payload } = action;
    const prSequence = yield PurchaseRequestServices.getPrSequence(payload);
    yield put(PurchaseRequestActions.getPrSequenceSuccess(prSequence?.data));
    yield put(PurchaseRequestActions.getPrSequenceLoading(false));
  } catch (error) {
    yield put(PurchaseRequestActions.getPrSequenceLoading(false));
    yield put(TrackerActions.trackAction(purchaseRequestActionTypes.GET_PURCHASE_REQUEST_SQN.ERROR, error));
  }
}

/**
 *
 */
function* getPrSequence() {
  yield takeLatest(purchaseRequestActionTypes.GET_PURCHASE_REQUEST_SQN.REQUEST, _getPrSequence);
}

/**
 * @param action
 */
function* _updatePrWorkflowStep(action) {
  try {
    yield put(PurchaseRequestActions.updatePrWorkflowStepLoading(true));
    const { payload } = action;
    const purchaseRequest = yield PurchaseRequestServices.updatePrWorkflowStep(payload);
    if (purchaseRequest.success) {
      notification.open({
        type: 'success',
        message: 'Material request approval status updated successfully',
        duration: 4,
        placement: 'top',
      });
      if (action.callback) {
        action.callback(purchaseRequest);
      }
    } else {
      notification.open({
        type: 'error',
        message: purchaseRequest.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(PurchaseRequestActions.updatePrWorkflowStepLoading(false));
  } catch (error) {
    yield put(PurchaseRequestActions.updatePrWorkflowStepLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(purchaseRequestActionTypes.UPDATE_PR_WORKFLOW_STEP.ERROR, error));
  }
}

/**
 *
 */
function* updatePrWorkflowStep() {
  yield takeLatest(purchaseRequestActionTypes.UPDATE_PR_WORKFLOW_STEP.REQUEST, _updatePrWorkflowStep);
}

function* _getMultiplePurchaseRequests(action) {
  try {
    yield put(PurchaseRequestActions.getMultiplePurchaseRequestsLoading(true));
    const { params, callback } = action;
    const {
      prIds, tenantIds, sourceTenantId,
    } = params;
    const purchaseRequests = yield PurchaseRequestServices.getPurchaseRequests(tenantIds, '', '', '', '', '', '', '', '', '', '', '', prIds, '', '', '', '', '', '', '', sourceTenantId);
    yield put(PurchaseRequestActions.getMultiplePurchaseRequestsSuccess(purchaseRequests));
    if (callback) {
      callback(purchaseRequests);
    }
    yield put(PurchaseRequestActions.getMultiplePurchaseRequestsLoading(false));
  } catch (error) {
    yield put(PurchaseRequestActions.getMultiplePurchaseRequestsLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(purchaseRequestActionTypes.GET_MULTIPLE_PURCHASE_REQUESTS.ERROR, error));
  }
}

/**
 *
 */
function* getMultiplePurchaseRequests() {
  yield takeLatest(purchaseRequestActionTypes.GET_MULTIPLE_PURCHASE_REQUESTS.REQUEST, _getMultiplePurchaseRequests);
}

/**
 *
 */
export default function* purchaseOrderSaga() {
  yield all([
    getPurchaseRequests(),
    downloadPRData(),
    getPurchaseRequestById(),
    createPurchaseRequest(),
    updatePurchaseRequest(),
    deletePurchaseRequest(),
    updatePurchaseRequestStatus(),
    getPrSequence(),
    updatePrWorkflowStep(),
    getMultiplePurchaseRequests(),
  ]);
}
